@let s = pageState();
@if (s.kind === 'pending') {
  <div class="bg-slate-50 min-h-screen" aria-busy="true">
    <app-marketing-header variant="home" />
    <p class="text-center py-24 text-slate-500">Loading preview…</p>
  </div>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1 class="text-xl font-semibold">Preview expired or invalid</h1>
    <a routerLink="/blogs" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Back to blogs</a>
  </div>
} @else {
  <div class="bg-slate-50 min-h-screen">
    <div class="cg-blog-preview-banner" role="status">Preview — not indexed by search engines</div>
    <app-marketing-header variant="home" />
    <article class="cg-blog-article">
      <div class="cg-container--marketing cg-blog-article__inner">
        <app-marketing-blog-breadcrumb
          [currentTitle]="s.page.post.title"
          [categoryName]="s.page.categories[0]?.name"
          [categorySlug]="s.page.categories[0]?.slug"
        />
        <header class="cg-blog-article__header">
          <h1 class="cg-blog-article__title">{{ s.page.post.title }}</h1>
          <p class="cg-blog-article__excerpt">{{ s.page.post.excerpt }}</p>
        </header>
        @if (s.page.featuredImage?.cdnUrl) {
          <figure class="cg-blog-article__hero">
            <img [src]="s.page.featuredImage!.cdnUrl" [alt]="s.page.featuredImage!.alt || s.page.post.title" />
          </figure>
        }
        <app-blog-renderer [content]="s.page.post.content" />
        <app-marketing-blog-guide-download [guide]="s.page.downloadableGuide" />
        <app-marketing-consultation-cta
          [cta]="s.page.consultationCta"
          [sourcePage]="sourcePage(s.page.post.slug)"
        />
      </div>
    </article>
    <app-marketing-footer />
  </div>
}
